import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function autoCompleteReducer(
  state = initialState.autoCompleteLoading,
  action
) {
  //updating the state basing on action data
  switch (action.type) {
    case types.SET_AUTOCOMPLETE_LOADING:
      return action.data;
    default:
      return state;
  }
}
